<template>
  <div v-if="result">
    <BookForm
    v-if="result"
    :params="params"
    :result="result"
    :pack="pack"
    :category="category"
    :meal="meal"
    @back="onBack"
    @book="onBook"
    />
  </div>
</template>

<script>
import model from './services/model'
import { getHotelInfo } from 'b2b-common/services/api/hotel'
import BookForm from './components/book_form'

export default {
  components: { BookForm },
  async created () {
    const routeParams = this.$route.params
    const result = model.results.find(el => el.id.toString() === routeParams.Result.toString())
    const pack = result.packages.find(el => el.id.toString() === routeParams.Package.toString())
    const category = pack.categories.find(el => el.id.toString() === routeParams.Category.toString())
    const meal = category.meals[routeParams.Meal]

    if (result.hotelInfo) return

    const hotelInfo = await getHotelInfo({ hotelId: result.id })

    this.$set(result, 'hotelInfo', hotelInfo[0])

    this.params = model.params
    this.result = result
    this.pack = pack
    this.category = category
    this.meal = meal
  },
  data () {
    return {
      params: null,
      result: null,
      pack: null,
      category: null,
      meal: null
    }
  },
  methods: {
    onBack () {
      // this.$router.push({ name: 'Private/Package/Search' })
      this.$router.push({ name: 'Private/' + ((this.params.packageType === 'package') ? 'Package' : 'Tour') + '/Search' })
    },
    onBook (id) {
      this.$router.push({ name: 'Private/Bookings/View', params: { Id: id } })
    }
  }
}
</script>
